import { render, staticRenderFns } from "./FUniswap.vue?vue&type=template&id=49d589ce&"
import script from "./FUniswap.vue?vue&type=script&lang=js&"
export * from "./FUniswap.vue?vue&type=script&lang=js&"
import style0 from "./FUniswap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports